import React, { useEffect, useState } from "react";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import EditIcon from '@material-ui/icons/Edit';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockIcon from '@material-ui/icons/Lock';
import Typography from '@mui/material/Typography';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert'
import DepartmentModelComponent from "./DepartmentModelComponent";
import axios from "../../../api/axios";
import { useAuthContext } from "../../../context/AuthContext";
const URL = './department';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
}));

const DepartmentList = () => {
    const columns = [
        { field: 'id', headerName: 'ID', width: 300 },
        {
            field: 'departmentName',
            headerName: 'Department name',
            width: 300,
            editable: true,
        },
        {
            field: 'departmentCode',
            headerName: 'Department Code',
            width: 300,
            editable: true,
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 300,
            cellClassName: 'actions',
            getActions: (params) => {
                return [
                    <EditData selectedRow={params.row} />,
                    <DeleteData selectedRow={params.row} />
                ];
            }
        },
    ];

    const [open, setOpen] = useState(false);
    const [isAddButton, setIsAddButton] = useState(true);
    const [editData, setEditData] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [isLoading, setGridLoading] = useState(true);
    const [refreshData, setRefreshData] = useState(false);
    const [trackno, setTrackno] = useState('');

    const [alertOpen, setAlertopen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [message, setMessage] = useState('');

    const handleClick = () => {
        setAlertopen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertopen(false);
    };


    const serviceMethod = async (mainURL, data, handleSuccess, handleException) => {
        try {
            const response = await axios.delete(mainURL, data);
            return handleSuccess(response.data);
        } catch (err) {
            if (!err?.response) {
                console.log("No server response");
            } else {
                return handleException(err?.response.data);
            }
        }
    };

    const serviceUpdateMethod = async (mainURL, data, handleSuccess, handleException) => {
        try {
            const response = await axios.post(mainURL, data);
            console.log(response.data.data);
        } catch (err) {
            if (!err?.response) {
                console.log("No server response");
            } else {
                return handleException(err?.response.data);
            }
        }
    };

    useEffect(() => {
        loadData();
    }, [refreshData]);

    const loadData = async () => {
        try {
            const response = await axios.get(URL);
            setDataList(response.data.message || '');
        } catch (err) {
            if (!err?.response) {
                console.log("No server response");
            } else {
                console.log(err?.response.data);
                setDataList('');
            }
        }
    };

    const EditData = (props) => {
        return (
            <EditIcon style={{ cursor: "pointer" }} onClick={(e) => {
                e.stopPropagation();
                console.log(props.selectedRow.id);
                setEditData(props.selectedRow);
                setIsAddButton(false);
                setOpen(true);
            }} />
        );
    };

    const DeleteData = (props) => {
        return (
            <DeleteIcon style={{ cursor: "pointer" }}
                onClick={() => {
                    console.log(props.selectedRow.id);
                    const data = { id: props.selectedRow.id };
                    const mainURL = './department' + '/' + data.id + '/delete';
                    serviceMethod(mainURL, data, handleSuccess, handleException);
                }}
            />
        );
    };

    const handleSuccess = (data) => {
        setSeverity("success");
        setMessage(data.message);
        setRefreshData((oldValue) => !oldValue);
        setAlertopen(true);
        setTimeout(() => {           
            setAlertopen(false);
        }, 1000); // Matches autoHideDuration
    };

    const handleException = (data) => {
        setSeverity("error");
        setMessage(data.message);
        setAlertopen(true);
    };

    const Block = (props) => {
        return (
            <>
                {
                    props.selectedRow.block == '0' ?
                        <LockOpenIcon
                            onClick={() => {
                                console.log(props.selectedRow.block);
                                var oldBlock = props.selectedRow.block;
                                var block = oldBlock == 1 ? 0 : 1;
                                const data = { id: props.selectedRow.id, block: block };
                                const mainURL = URL + '/' + data.id + '/updateBlockStatus';
                                serviceUpdateMethod(mainURL, data, handleSuccess, handleException);
                            }}
                        /> :
                        <LockIcon
                            onClick={() => {
                                console.log(props.selectedRow.block);
                                var oldBlock = props.selectedRow.block;
                                var block = oldBlock == 1 ? 0 : 1;
                                const data = { id: props.selectedRow.id, block: block };
                                const mainURL = URL + '/' + data.id + '/updateBlockStatus';
                                serviceUpdateMethod(mainURL, data, handleSuccess, handleException);
                            }}
                        />
                }
            </>
        );
    };


    return (
        <div style={{ marginTop: '75px', padding: '25px' }}>
            <div className="topContent">
                <Box sx={{ flexGrow: 1, padding: '10px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={10} />
                        <Grid item xs={2}>
                            <Button variant="contained"
                               sx={{
                                backgroundColor: '#0d2365',
                                color: 'white',  // Change background color to purple
                                '&:hover': {
                                    backgroundColor: '#0d2365',  // Darken the color on hover
                                },
                                borderRadius: '10px'
                            }}

                                onClick={(e) => {
                                    setIsAddButton(true);
                                    setOpen(true);
                                    setEditData([]);
                                }}
                            >
                                Add Department
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </div>
            <div className="GridContent">
                <Box sx={{ flexGrow: 1, padding: '0px', height: 400, width: '100%' }}>
                    <DataGrid
                        rows={dataList}
                        columns={columns}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        experimentalFeatures={{ newEditingApi: true }}
                        components={{
                            Toolbar: () => (
                                <Box
                                    sx={{
                                        padding: 2,
                                        display: 'flex',
                                        justifyContent: 'flex-start', // Aligns to the left
                                        borderBottom: '2px solid #3f51b5', // Adds bottom border
                                    }}
                                >
                                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'darknavy' }}>
                                        Department
                                    </Typography>
                                </Box>
                            ),
                        }}
                        sx={{
                            '& .MuiDataGrid-columnHeaderTitle': {
                                color: 'darknavy', // Set column header text color to dark navy blue
                                fontWeight: 'bold', // Make column header text bold
                            },
                        }}
                    />
                    <DepartmentModelComponent
                        isAddButton={isAddButton}
                        setOpen={setOpen}
                        open={open}
                        rowData={editData}
                        setRefreshData={setRefreshData}
                        trackno={trackno}
                    />
                    <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleClose}>
                        <Alert
                            onClose={handleClose}
                            severity={severity}
                            variant="filled"
                            sx={{ width: '100%' }}
                        >
                            {message}
                        </Alert>
                    </Snackbar>
                </Box>
            </div>
        </div>
    );
};

export default DepartmentList;
